import { GALLERY_PAGE_SIZE } from 'client/data/models/photoflipper';

const PICTURE_SIZE_MAP = { true: '_300.jpg', false: '_500.jpg' };

export const getPagesCount = totalPhotosCount => Math.ceil(totalPhotosCount / GALLERY_PAGE_SIZE);

export const getPictureNumber = ({ pageNum, ind }) => (pageNum - 1) * GALLERY_PAGE_SIZE + ind + 1;

export const getPictureSrc = (imageSrc, isMobile) => imageSrc.replace('_815.jpg', PICTURE_SIZE_MAP[isMobile]);
